import { render } from "./RecentVersion.vue?vue&type=template&id=1c162cb7&scoped=true"
import script from "./RecentVersion.vue?vue&type=script&lang=js"
export * from "./RecentVersion.vue?vue&type=script&lang=js"

import "./RecentVersion.vue?vue&type=style&index=0&id=1c162cb7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c162cb7"]])

export default __exports__